import React, { useEffect } from "react";
import Grid from "@mui/material/Grid";

import RegisteredUsers from "./elements/RegisteredUsers";

import HighestSubscription from "./elements/HighestSubscription";

import MonthlyRevenue from "./elements/MonthlyRevenue";
import { useSelector } from "react-redux";

export default function Dashboard() {
  const registeredUsers = useSelector((state) => state.dashboard.totalusers);

  const sale_data = useSelector((state) => state?.dashboard?.sale_data);
  console.log(sale_data, "newSaleData");

  const monthlyrevenue = useSelector((state) => state.dashboard?.sale_data);

  return (
    <>
      <RegisteredUsers registeredUsers={registeredUsers} />

      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
        <Grid item xs={12} md={12} lg={12} xl={8}>
          {/* <Features dashboardcount={dashboardcount} /> */}

          <Grid container columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
            <Grid item xs={12} md={12}>
              <MonthlyRevenue monthlyrevenue={monthlyrevenue} />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} md={12} lg={12} xl={4}>
          <HighestSubscription
            data={sale_data?.weekly_sales}
            total_weekly_sale={sale_data?.total_weekly_sale}
          />
        </Grid>
      </Grid>
    </>
  );
}
